<template>
  <div
    class="personal-offers-slider"
    :class="_.get(contentData, 'conf.background.white') ? 'white-bg' : ''"
    v-if="_.size(_.get(contentData, 'data.list'))"
  >
    <div class="personal-offers-slider__content">
      <div class="flex between personal-offers-slider__title-wrapper al-center">
        <div class="personal-offers-slider__title font-21 bold uppercase">
          {{ _.get(contentData, "conf.header.title") }}
        </div>
        <div class="personal-offers-slider__navigation flex">
          <div class="white personal-offers-slider__prev">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="7.857"
              height="10"
              viewBox="0 0 7.857 10"
            >
              <path
                id="Icon_material-play-arrow"
                data-name="Icon material-play-arrow"
                d="M12,7.5v10l7.857-5Z"
                transform="translate(19.857 17.5) rotate(180)"
                fill="#4d4d4f"
              />
            </svg>
          </div>

          <div class="white personal-offers-slider__next">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="7.857"
              height="10"
              viewBox="0 0 7.857 10"
            >
              <path
                id="Icon_material-play-arrow"
                data-name="Icon material-play-arrow"
                d="M0,10V0L7.857,5Z"
                fill="#4d4d4f"
              />
            </svg>
          </div>
        </div>
      </div>

      <swiper
        ref="gallery"
        class="personal-offers-slider-gallery"
        :options="swiperOptions"
      >
        <swiper-slide
          class="single-slide"
          v-for="(item, index) in filteredList"
          :key="index"
        >
          <CabinetSlide @click.native="openPopup(item)" :slide_content="item" />
        </swiper-slide>
      </swiper>
    </div>
    <portal to="modal">
      <StorePopup :isOffers="true" v-if="$store.state.main.store_pop_up" />
    </portal>
  </div>
</template>

<script>
import StorePopup from "@/components/modals/StorePopup";
import CabinetSlide from "@/components/modules/cabinet/CabinetSlide";
export default {
  components: { CabinetSlide, StorePopup },
  props: ["contentData", "background"],
  data() {
    return {
      swiperOptions: {
        speed: 1000,
        slidesPerView: "auto",
        spaceBetween: 30,
        watchOverflow: true,
        grabCursor: true,
        navigation: {
          nextEl: ".personal-offers-slider__next",
          prevEl: ".personal-offers-slider__prev"
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            spaceBetween: 30
          },
          1024: {
            slidesPerView: 2,

            spaceBetween: 30
          },
          1366: {
            slidesPerView: 2,
           
            spaceBetween: 15
          },
          1551: {
            slidesPerView: "auto",
            spaceBetween: 30
          }
        }
      }
    };
  },

  computed: {
    filteredList() {
      const activeCategory = this.$store.state.main.cache.unicardUserInfo
        .category;
      const list = _.get(this.contentData, "data.list");
      const UNICARD_CATEGORIES = this.$store.state.main.indx.terms.unicard_category.filter(
        f => f.unicardId == activeCategory.toString()
      );
      const newList = list.filter(
        offer =>
          offer.unicard_category &&
          offer.unicard_category.includes(UNICARD_CATEGORIES[0].id)
      );
      return newList;
    }
  },

  methods: {
    openPopup(data) {
      this.$store.commit("main/setState", { key: "store_pop_up", val: true });
      this.$store.commit("main/setState", {
        key: "store_modal_data",
        val: data
      });
    }
  }
};
</script>

<style lang="scss">
.personal-offers-slider {
  padding-top: 55px;
  width: 962px;
  overflow: hidden;
  .swiper-container{
    padding-left: 30px;
    padding-right: 30px;
    overflow: visible;
    @media (max-width: 1023px){
      overflow: hidden;
    }
  }
  .swiper-wrapper {
    transition-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  }
  .swiper-slide {
    width: 406px;
  }

  &__next {
    margin-left: 20px;
  }
  &__next,
  &__prev {
    background-color: white;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    box-shadow: 0px 0px 10px rgba(#1a1a1a, 0.1);
    cursor: pointer;
    transition: 0.4s;
    &.swiper-button-disabled {
      opacity: 0.3;
      cursor: default;
    }
  }
  &__title-wrapper {
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 21px;
    padding-top: 55px;
  }

  &.white-bg {
    background: #fff;
  }
  .view-all {
    color: $black;
  }
  &__content {
    position: relative;
    background-color: white;
    padding-bottom: 34px;
    .title {
      font-size: 21px;
      line-height: 24px;
      margin-bottom: 17px;
    }
  }

  @media (max-width: 1550px) {
    width: 770px;
    .swiper-slide {
      width: 325px;
    }
  }
  @media (max-width: 1440px) {
    width: 621px;
    .swiper-slide {
      width: 262px;
    }
    &__title-wrapper {
      padding-bottom: 37px;
    }
    &__content {
      padding-bottom: 55px;
    }
  }
  @media (max-width: 1439px) {
    width: 714px;
    .swiper-slide {
      // width: 301px;
      width: auto;

    }
  }
  @media (max-width: 1365px) {
    width: 100%;
    overflow: hidden;
    .swiper {
      &-slide {
        width: 262px;
      }
      &-container {
        overflow: visible;
      }
    }
  }
  @media (max-width: 1125px) {
    width: 100%;
    overflow: hidden;
    .swiper {
      &-slide {
        width: 42%;
      }
      &-container {
        overflow: visible;
      }
    }
  }
  @media (max-width: 1023px) {
    width: 100%;
    overflow: hidden;
    .swiper {
      &-slide {
        // width: 42%;
        // padding-right: 30px;
        width: auto;
      }
      &-container {
        overflow: visible;
        padding-left: 30px;
      }
    }
  }
  @media (max-width: 767px) {
    &__title-wrapper {
      padding-left: 13px;
      padding-right: 13px;
      padding-bottom: 21px;
    }
    &__content {
      padding-bottom: 0;
    }
    .swiper {
      &-container {
        padding-left: 13px;
        padding-right: 13px;
      }
      &-slide {
        // padding-right: 13px;
      }
    }
  }
  @media (max-width: 413px) {
    &__title-wrapper {
      flex-direction: column;
    }
    &__title {
      text-align: center;
      margin-bottom: 21px;
    }
  }
}
</style>
